import {  registerBrick } from 'olympe';
import {ReactBrick, useProperty} from "@olympeio/core";
import React from "react";
import {combineLatest} from "rxjs";

export default class Dentition extends ReactBrick {

    /**
     * @override
     */
    setupExecution($) {
        return combineLatest([
            $.observe('Hidden', false),
        ]);
    }
    /**
     * @override
     */
    static getReactComponent($) {

        return (props) => {
            const [hidden] = props.values;
            const highlighted = useProperty($, 'highlighted');
            const color = useProperty($, 'highlight color');

            const getBackground = (tooth) => {
                return highlighted?.map(a => Number(a)).includes(tooth) ? color : "transparent";
            }

            const handleClick = (tooth) => {
                const indexOfTooth = highlighted?.map(a => Number(a)).indexOf(tooth);
                if (indexOfTooth >= 0) {
                    const newHighlight = highlighted.slice(0, indexOfTooth).concat(highlighted.slice(indexOfTooth+1));
                    $.set('highlighted', newHighlight);
                } else {
                    const newHighlight = highlighted ? highlighted.concat([tooth]) : [tooth];
                    $.set('highlighted', newHighlight);
                }
            }

            return !hidden && (<div>
                <div>
                    <div style={{ height: '26px', width: '200px', display: 'inline-block', borderRight: "1px solid black", borderBottom: "1px solid black", padding:"0 5px"}}>
                    {
                        [18, 17, 16, 15, 14, 13, 12, 11].map(tooth => {
                            return (
                                <div
                                    style={{
                                        height: '25px',
                                        width: '25px',
                                        display: 'inline-block',
                                        fontFamily: "Roboto",
                                        fontSize: "1rem",
                                        textAlign: "center",
                                        lineHeight: "25px",
                                        cursor: "pointer",
                                        boxSizing: "border-box",
                                        backgroundColor: getBackground(tooth),
                                        borderRadius: "15px"
                                    }}
                                    onClick={() => handleClick(tooth)}
                                >
                                    {tooth}
                                </div>
                            )
                        })
                    }
                    </div>
                    <div style={{ height: '26px', width: '200px', display: 'inline-block', borderBottom: "1px solid black", padding:"0 5px", marginRight: "75px"}}>
                    {
                        [21, 22, 23, 24, 25, 26, 27, 28].map(tooth => {
                            return (
                                <div
                                    style={{
                                        height: '25px',
                                        width: '25px',
                                        display: 'inline-block',
                                        fontFamily: "Roboto",
                                        fontSize: "1rem",
                                        textAlign: "center",
                                        lineHeight: "25px",
                                        cursor: "pointer",
                                        boxSizing: "border-box",
                                        backgroundColor: getBackground(tooth),
                                        borderRadius: "15px"
                                    }}
                                    onClick={() => handleClick(tooth)}
                                >
                                    {tooth}
                                </div>
                            )
                        })
                    }
                    </div>


                    <div style={{ height: '26px', width: '125px', display: 'inline-block', borderRight: "1px solid black", borderBottom: "1px solid black", padding:"0 5px"}}>
                        {
                            [55, 54, 53, 52, 51].map(tooth => {
                                return (
                                    <div
                                        style={{
                                            height: '25px',
                                            width: '25px',
                                            display: 'inline-block',
                                            fontFamily: "Roboto",
                                            fontSize: "1rem",
                                            textAlign: "center",
                                            lineHeight: "25px",
                                            cursor: "pointer",
                                            boxSizing: "border-box",
                                            backgroundColor: getBackground(tooth),
                                            borderRadius: "15px"
                                        }}
                                        onClick={() => handleClick(tooth)}
                                    >
                                        {tooth}
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div style={{ height: '26px', width: '125px', display: 'inline-block', borderBottom: "1px solid black", padding:"0 5px"}}>
                        {
                            [61, 62, 63, 64, 65].map(tooth => {
                                return (
                                    <div
                                        style={{
                                            height: '25px',
                                            width: '25px',
                                            display: 'inline-block',
                                            fontFamily: "Roboto",
                                            fontSize: "1rem",
                                            textAlign: "center",
                                            lineHeight: "25px",
                                            cursor: "pointer",
                                            boxSizing: "border-box",
                                            backgroundColor: getBackground(tooth),
                                            borderRadius: "15px"
                                        }}
                                        onClick={() => handleClick(tooth)}
                                    >
                                        {tooth}
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>



                <div>
                    <div style={{ width: '200px', display: 'inline-block', borderRight: "1px solid black", padding:"0 5px"}}>
                    {
                        [48, 47, 46, 45, 44, 43, 42, 41].map(tooth => {
                            return (
                                <div
                                    style={{
                                        height: '25px',
                                        width: '25px',
                                        display: 'inline-block',
                                        fontFamily: "Roboto",
                                        fontSize: "1rem",
                                        textAlign: "center",
                                        lineHeight: "25px",
                                        cursor: "pointer",
                                        boxSizing: "border-box",
                                        backgroundColor: getBackground(tooth),
                                        borderRadius: "15px"
                                    }}
                                    onClick={() => handleClick(tooth)}
                                >
                                    {tooth}
                                </div>
                            )
                        })
                    }
                    </div>
                    <div style={{ width: '200px', display: 'inline-block', padding:"0 5px", marginRight: "75px"}}>
                    {
                        [31, 32, 33, 34, 35, 36, 37, 38].map(tooth => {
                            return (
                                <div
                                    style={{
                                        height: '25px',
                                        width: '25px',
                                        display: 'inline-block',
                                        fontFamily: "Roboto",
                                        fontSize: "1rem",
                                        textAlign: "center",
                                        lineHeight: "25px",
                                        cursor: "pointer",
                                        boxSizing: "border-box",
                                        backgroundColor: getBackground(tooth),
                                        borderRadius: "15px"
                                    }}
                                    onClick={() => handleClick(tooth)}
                                >
                                    {tooth}
                                </div>
                            )
                        })
                    }
                    </div>



                    <div style={{ width: '125px', display: 'inline-block', borderRight: "1px solid black", padding:"0 5px"}}>
                        {
                            [85, 84, 83, 82, 81].map(tooth => {
                                return (
                                    <div
                                        style={{
                                            height: '25px',
                                            width: '25px',
                                            display: 'inline-block',
                                            fontFamily: "Roboto",
                                            fontSize: "1rem",
                                            textAlign: "center",
                                            lineHeight: "25px",
                                            cursor: "pointer",
                                            boxSizing: "border-box",
                                            backgroundColor: getBackground(tooth),
                                            borderRadius: "15px"
                                        }}
                                        onClick={() => handleClick(tooth)}
                                    >
                                        {tooth}
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div style={{ width: '125px', display: 'inline-block', padding:"0 5px"}}>
                        {
                            [71, 72, 73, 74, 75].map(tooth => {
                                return (
                                    <div
                                        style={{
                                            height: '25px',
                                            width: '25px',
                                            display: 'inline-block',
                                            fontFamily: "Roboto",
                                            fontSize: "1rem",
                                            textAlign: "center",
                                            lineHeight: "25px",
                                            cursor: "pointer",
                                            boxSizing: "border-box",
                                            backgroundColor: getBackground(tooth),
                                            borderRadius: "15px"
                                        }}
                                        onClick={() => handleClick(tooth)}
                                    >
                                        {tooth}
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>

            </div>);
        }
    }
}

registerBrick('0190ed86a23142ad07f3', Dentition);
